export default __webpack_public_path__ + "static/media/sandal.5bf641cf.png";